import { createHashHistory } from 'history';
const history = createHashHistory({
    hash: 'hash'
});

export default history;